/**
 * Shimmer image loading handler for the public event site.
 *
 * Manages the transition from shimmer placeholder to loaded image.
 * Hides the shimmer once the image loads. If loading fails, removes the image
 * element and — when a fallback selector is supplied — reveals the fallback
 * placeholder (e.g. a missing S3 upload, PEARS-8146) instead of leaving an
 * empty box. Used on the public event listing and detail pages.
 *
 * @param imgDataValue the data-js selector for the image
 * @param shimmerDataValue the data-js selector for the shimmer div
 * @param fallbackDataValue optional data-js selector for a placeholder to reveal on error
 */
window.SetupShimmerImages = function(imgDataValue, shimmerDataValue, fallbackDataValue) {
  document.querySelectorAll(`[data-js="${imgDataValue}"]`).forEach((img) => {
    const shimmer = img.parentElement.querySelector(`[data-js="${shimmerDataValue}"]`),
          fallback = fallbackDataValue ? img.parentElement.querySelector(`[data-js="${fallbackDataValue}"]`) : null,
          handleError = () => {
            img.remove();
            if (fallback) fallback.classList.remove('d-none');
          };
    if (img.complete) {
      if (img.naturalWidth > 0) {
        img.classList.remove('invisible');
      } else {
        handleError();
      }
      if (shimmer) shimmer.remove();
    } else {
      img.addEventListener('load', () => {
        img.classList.remove('invisible');
        if (shimmer) shimmer.remove();
      });
      img.addEventListener('error', () => {
        if (shimmer) shimmer.remove();
        handleError();
      });
    }
  });
};
